export const GOTO_LOGIN = 'GOTO_LOGIN';
export const LOGIN_TRIGGER = 'LOGIN_TRIGGER';
export const LOGIN_API_REQUEST = 'LOGIN_API_REQUEST';
export const LOGIN_API_SUCCESS = 'LOGIN_API_SUCCESS';
export const LOGIN_API_FAILURE = 'LOGIN_API_FAILURE';
